import {INavState, INav} from 'features/layout/redux/helpers/FoldersHelper';
import {each} from 'lodash';
import {IDiplomatFolder} from 'types/DiplomatFolder';
import {DiplomatObjectType} from 'types/DiplomatObjectType';

export const KEYS_FOLDER_NAME = 'Keys';
export const isKeysFolder = (folder: IDiplomatFolder) => {
   return folder.name === KEYS_FOLDER_NAME;
};
export const OPEN_PGP_KEYS_FOLDER_NAME = 'OpenPGP Keys';
export const isOpenPgpKeysFolder = (folder: IDiplomatFolder) => {
   return folder.name === OPEN_PGP_KEYS_FOLDER_NAME;
};
export const SSH_KEYS_FOLDER_NAME = 'SSH Keys';
export const isSshKeysFolder = (folder: IDiplomatFolder) => {
   return folder.name === SSH_KEYS_FOLDER_NAME;
};
export const SSH_KEY_PAIRS_FOLDER_NAME = 'SSH Key Pairs';
export const isSshKeyPairsFolder = (folder: IDiplomatFolder) => {
   return folder.name === SSH_KEY_PAIRS_FOLDER_NAME;
};

export const TRANSACTIONS_FOLDER_NAME = 'Transactions';
export const isTransactionsFolder = (folder: IDiplomatFolder) => {
   return folder.name === TRANSACTIONS_FOLDER_NAME;
};

export const PARTNERS_FOLDER_NAME = 'Partners';
export const isPartnerFolder = (folder: IDiplomatFolder) => {
   if (folder.name === PARTNERS_FOLDER_NAME) {
      return true;
   }

   return (
      folder.childObjectType &&
      (folder.childObjectType === DiplomatObjectType.enum.EXTERNAL_PARTNER ||
         folder.childObjectType === DiplomatObjectType.enum.INTERNAL_PARTNER)
   );
};

export const SSL_CERTS_FOLDER_NAME = 'SSL Certificates';
export const isSslCertsFolder = (folder: IDiplomatFolder) => {
   return folder.name === SSL_CERTS_FOLDER_NAME;
};
export const SSL_SERVER_CERTS_FOLDER_NAME = 'Server SSL Certificates';
export const isSslServerCertsFolder = (folder: IDiplomatFolder) => {
   return folder.name === SSL_SERVER_CERTS_FOLDER_NAME;
};
export const SSL_CLIENT_CERTS_FOLDER_NAME = 'Client SSL Certificates';
export const isSslClientCertsFolder = (folder: IDiplomatFolder) => {
   return folder.name === SSL_CLIENT_CERTS_FOLDER_NAME;
};

export const SFTP_SERVER_FOLDER_NAME = 'File Transfer Server';
export const isSftpServerFolder = (folder: IDiplomatFolder) => {
   return folder.name === SFTP_SERVER_FOLDER_NAME;
};

export const SYNCHRONIZATION_FOLDER_NAME = 'Synchronization';
export const isSynchroniztionFolder = (folder: IDiplomatFolder) => {
   return folder.name === SYNCHRONIZATION_FOLDER_NAME;
};

export const INBOUND_FOLDER_NAME = 'Inbound';
export const OUTBOUND_FOLDER_NAME = 'Outbound';

export function flatThroughTree(
   result: INavState[],
   nodes: INav[],
   depth: number = 0,
   expandedIds?: string[]
) {
   each(nodes, (node, i) => {
      const isExpanded = expandedIds?.some((id) => id === node.id);
      result.push({
         ...node,
         _state: {
            depth,
            expanded: isExpanded,
         },
      });
      node.child && isExpanded && flatThroughTree(result, node.child, depth + 1, expandedIds);
   });
}
